module.exports = __webpack_public_path__ + "fonts/Inter-300-latin-ext23.fad2a54.woff2";